import { A11yModule } from '@angular/cdk/a11y';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  computed,
  input,
  linkedSignal,
  output,
  viewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Modal } from 'flowbite';
import { IRouteSetupCopySchedules } from 'src/app/models';
import { LiteralService } from 'src/app/services';
import { images } from 'src/images';

@Component({
  selector: 'app-modal-copy-schedules',
  templateUrl: './modal-copy-schedules.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [A11yModule, FormsModule],
})
export class ModalCopySchedulesComponent {
  readonly modal = input<Modal>();
  readonly shown = input<boolean>(false);
  readonly days = input.required<{ id: string; name: string }[]>();
  readonly sourceDays = input<string[]>([]);
  readonly selectedSchedulesCount = input<number>(0);
  readonly action = output<IRouteSetupCopySchedules>();

  readonly container = viewChild.required<ElementRef<HTMLElement>>('container');

  readonly images = images;

  readonly targetDays = linkedSignal<boolean, string[]>({
    source: this.shown,
    computation: () => [],
  });
  readonly replaceExisting = linkedSignal<boolean, boolean>({
    source: this.shown,
    computation: () => false,
  });

  readonly dayOptions = computed(() => {
    const sourceDays = new Set(this.sourceDays());
    const targetDays = new Set(this.targetDays());
    return this.days().map((day) => ({
      id: day.id,
      label: this.literalService.get(day.name, true),
      isSource: sourceDays.has(day.id),
      checked: targetDays.has(day.id),
    }));
  });

  readonly summary = computed(() =>
    this.literalService.get('setup.modal.copySchedules.summary', true, {
      count: this.selectedSchedulesCount(),
    }),
  );

  constructor(public literalService: LiteralService) {}

  toggleTargetDay(dayId: string, checked: boolean) {
    this.targetDays.update((targetDays) =>
      checked
        ? [...targetDays, dayId]
        : targetDays.filter((targetDay) => targetDay !== dayId),
    );
  }

  close() {
    this.modal()?.hide();
  }

  onSubmit() {
    if (this.targetDays().length === 0) return;
    this.action.emit({
      targetDays: this.targetDays(),
      replaceExisting: this.replaceExisting(),
    });
  }
}
